import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({ value, width = 2, height = 100, displayValue = true, fontSize = 12 }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current) {
      JsBarcode(svgRef.current, value.toString(), {
        format: 'CODE128',
        width,
        height,
        displayValue,
        fontSize,
        margin: 10,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, width, height, displayValue]);

  return <svg ref={svgRef} />;
};

export default Barcode;
